import { createRoot, createElement } from '@wordpress/element';
import AlphaLibraryModalComponent from './AlphaLibraryModalComponent.jsx';

// Render the modal component into the DOM
const container = document.createElement( 'div' );
container.id = 'alpha-library-modal-root';
document.body.appendChild( container );
const root = createRoot( container );
root.render( createElement( AlphaLibraryModalComponent ) );

// Header toolbar button code
( function ( window ) {
	var wp = window.wp;
	var alpha = window.alpha;
	var link_id = 'alpha_library';
	var link_html =
		'<a id="' +
		link_id +
		'" class="components-button components-toolbar__control editor-document-tools__inserter-toggle is-primary" href="#" >' +
		alpha?.alphaLibraryText +
		'</a>';
	var editorEl = document.getElementById( 'editor' );
	if ( ! editorEl ) {
		return;
	}
	var unsubscribe =
		wp && wp.data && wp.data.subscribe
			? wp.data.subscribe( function () {
					setTimeout( function () {
						if ( ! document.getElementById( link_id ) ) {
							var toolbalEl = editorEl.querySelector(
								'.edit-post-header-toolbar'
							);
							if ( toolbalEl instanceof HTMLElement ) {
								toolbalEl.insertAdjacentHTML(
									'beforeend',
									link_html
								);
							}
						}
						var alphaBtn = document.getElementById( link_id );
						if ( alphaBtn ) {
							alphaBtn.addEventListener( 'click', function ( e ) {
								e.preventDefault();
								window.dispatchEvent(
									new Event( 'alphaLibraryOpen' )
								);
							} );
						}
					}, 1 );
			  } )
			: null;
} )( window );
